export default __webpack_public_path__ + "static/media/logo-gita-1.6d29f3e8.png";